import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {Container} from '../shared/HelpCenterMobileNavigation';

export const LoadingPlaceholder = () => {
  return (
    <Container $noBorder>
      <SkeletonBlock
        disableSpaceBelow
        style={{margin: 'auto'}}
        $width="180px"
        $height="30px"
      />
    </Container>
  );
};
